import type { FormSectionTitleProps } from './FormSectionTitle'
import FormSectionTitle from './FormSectionTitle'

export type { FormSectionTitleProps }
export default FormSectionTitle
